import React from "react";
import { useQuery } from "react-query";
import { getProducerCode } from "../../../../actions/CarrierAgreementMgmt/ProducerCodeConfig";
import { toast } from "../../../../components/toastNotification";

const useGetProducerCodes = () => {
  return useQuery("ProducerCode", getProducerCode, {
    refetchOnWindowFocus: false,
    onSuccess: (res) => {
      if (res) {
        if (res.statusCode === 500 || res.statusCode === 400) {
          toast.fire("Server Error", "Cannot display data", "error");
        } else {
          return res;
        }
      } else {
        toast.fire("No Data:", "No avaible data to display.", "info");
      }
    },
  });
};

export default useGetProducerCodes;
